import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-add-branding-config',
  templateUrl: './add-branding-config.component.html',
  styleUrls: ['./add-branding-config.component.css']
})
export class AddBrandingConfigComponent {

}
